var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,{tag:"component",attrs:{"clientType":_vm.clientType,"context":_vm.$route.query.context,"email":_vm.$route.query.email,"error":_vm.error,"form":_vm.form,"mfaType":_vm.$route.query.mfaType,"redirectTo":_vm.$route.query.redirectTo,"requestKey":_vm.$route.query.key,"step":_vm.$route.query.step,"success":_vm.success}})
}
var staticRenderFns = []

export { render, staticRenderFns }